import React from 'react';

export const OptionsIcon = () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.58594 3.21875C9.2207 3.69336 8.64648 4 8 4C7.54883 4 7.13281 3.85156 6.79688 3.59961C6.3125 3.23438 6 2.6543 6 2C6 0.894531 6.89453 0 8 0C9.10547 0 10 0.894531 10 2C10 2.45898 9.8457 2.88281 9.58594 3.21875Z"
            fill="inherit"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 8C10 9.10547 9.10547 10 8 10C6.89453 10 6 9.10547 6 8C6 6.89453 6.89453 6 8 6C8.64062 6 9.21094 6.30078 9.57617 6.76953C9.8418 7.10938 10 7.53516 10 8Z"
            fill="inherit"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.70117 15.0527C9.34961 15.6211 8.71875 16 8 16C6.89453 16 6 15.1055 6 14C6 12.8945 6.89453 12 8 12C9.10547 12 10 12.8945 10 14C10 14.3867 9.89062 14.748 9.70117 15.0527Z"
            fill="inherit"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.58594 3.21875C3.2207 3.69336 2.64648 4 2 4C1.54883 4 1.13281 3.85156 0.796875 3.59961C0.3125 3.23438 0 2.6543 0 2C0 0.894531 0.894531 0 2 0C3.10547 0 4 0.894531 4 2C4 2.45898 3.8457 2.88281 3.58594 3.21875Z"
            fill="inherit"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4 8C4 9.10547 3.10547 10 2 10C0.894531 10 0 9.10547 0 8C0 6.89453 0.894531 6 2 6C2.64062 6 3.21094 6.30078 3.57617 6.76953C3.8418 7.10938 4 7.53516 4 8Z"
            fill="inherit"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.70117 15.0527C3.34961 15.6211 2.71875 16 2 16C0.894531 16 0 15.1055 0 14C0 12.8945 0.894531 12 2 12C3.10547 12 4 12.8945 4 14C4 14.3867 3.89062 14.748 3.70117 15.0527Z"
            fill="inherit"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.5859 3.21875C15.2207 3.69336 14.6465 4 14 4C13.5488 4 13.1328 3.85156 12.7969 3.59961C12.3125 3.23438 12 2.6543 12 2C12 0.894531 12.8945 0 14 0C15.1055 0 16 0.894531 16 2C16 2.45898 15.8457 2.88281 15.5859 3.21875Z"
            fill="inherit"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 8C16 9.10547 15.1055 10 14 10C12.8945 10 12 9.10547 12 8C12 6.89453 12.8945 6 14 6C14.6406 6 15.2109 6.30078 15.5762 6.76953C15.8418 7.10938 16 7.53516 16 8Z"
            fill="inherit"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.7012 15.0527C15.3496 15.6211 14.7188 16 14 16C12.8945 16 12 15.1055 12 14C12 12.8945 12.8945 12 14 12C15.1055 12 16 12.8945 16 14C16 14.3867 15.8906 14.748 15.7012 15.0527Z"
            fill="inherit"
        />
    </svg>
);
